import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const ProjectUserDeleteModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    deleteMode, submitted,
    // event handlers
    onConfirmDeleteClick, onCancelClick,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_remove_users'
    buttonMessageKey='c_yes_remove'
    cancelMessageKey='c_do_not_remove'

    isOpen={deleteMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onConfirmDeleteClick}
    busy={submitted}
  >
    <MessageUI messageList={messageList} messageKey='c_remove_users_conf' />
  </ModalFormUI>

export default ProjectUserDeleteModalUI
